<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchAllStoriesText" class="search-components textBox" type="text" placeholder="Search Stories here..."
          [(ngModel)]="str" (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true"
          (focusout)="searchFocus = false" autofocus />
        <ng-container *ngIf="listSuggestionArray && listSuggestionArray.length > 0">
          <div [ngClass]="(showSuggestionBox) ? 'block' : '' " class="autosuggestion" *ngIf="listSuggestionArray">
            <ul>
              <ng-container *ngFor="let item of listSuggestionArray; let i = index ; trackBy: trackByName; ">
                <li [class.active]="i == arrowkeyLocation">
                  <span class="name" (click)="getsearchResults(item)">{{item}}</span>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="filterSection spImg">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        <div class="searchfilter">
          <span id="exactAllStoriesButton" [class]="exactMatch ? 'exact green' : 'exact'" (click)="toggleSwitch('exact')" tabindex="0"
            (keydown)="callToggles($event, 'exact')">
            Exact & Latest
          </span>
        </div>
        <ul class="filterOption">
          <ng-container *ngIf="filterList && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
              </li>
              <span #moreButtonEl id="{{(showMore) ? 'lessFilter' : 'moreFilter'}}" tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList && filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="closebg"></div>
  </div>

  <!--  -->
<div class="storyMobScroll">
  <div class="headingsList">
    <ul>
      <ng-container *ngFor="let header of headerList">
        <li [class]="header.class">{{header.name}}</li>
      </ng-container>
    </ul>
  </div>
  <div class="contentList" id="storiesListing">
    <ng-template #loading>
      <div style="text-align: center; display: inline-block; width: 100%;">
        <ng-container *ngIf="callFail">
          <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
            Sorry, Server Error
          </div>
        </ng-container>
        <ng-container *ngIf="!callFail">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #nores>
      <div id="textNoData" style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
    </ng-template>
    <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
    <ng-template #listData>
      <ng-container *ngIf="listArray && listArray.length > 0;else loading">
        <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">

          <div #dive [class]="(checkFocusInside(dive)) ? 'storyListing focused' : 'storyListing'">
            <div class='story_status'>
              <ng-container *ngIf="automaticQuickReadEnabled && item.type === 'story'">
              <em class="quick_read" (click)="openQuickRead(i)">
                <ng-container *ngIf="checkColorOfQuickRead(item)">
                  <img [src]="quickReadSrc" alt="" >
                </ng-container>
                <div class="arrow_box single">QuickRead : {{item.quickReadStatus ? item.quickReadStatus : 'None' }}</div>
              </em>
              </ng-container>
              <!-- for summary status-->
              <ng-container *ngIf="automaticSummaryReadEnabled && item.type === 'story'">
              <em class="quick_read summary_read">
                <ng-container *ngIf="checkColorOfSummaryRead(item)">
                  <img [src]="summaryStatus" alt="" >
                </ng-container>
                <div class="arrow_box single">Summary : {{item.summaryStatus ? item.summaryStatus : 'None' }}</div>
              </em>
              </ng-container>
              <em #unlockDropdown [class]="getclassonCondition(item.lockedByUserId, item.metadata.status)"
                (click)="openOptions(i)">
                <div class="arrow_box single" *ngIf="(item.lockedByUserId && unlockOptions !== i)">
                  {{item.lockedByUserName}}</div>
                <div class="revertStoryBlock" *ngIf="unlockOptions === i">
                  <ul *ngIf="item.type !== 'video'" class="list-padding">
                    <li>
                      <button (click)="openUnlock(i)">Unlock</button>
                    </li>
                    <li>
                      <button (click)="copyUrl(i)">Copy Url</button>
                    </li>
                  </ul>
                  <ul *ngIf="item.type === 'video'">
                    <li *ngIf="item.lockedByUserId">
                      <button (click)="openUnlock(i)">Unlock</button>
                    </li>
                    <li>
                      <button (click)="copyUrl(i)">Copy Url</button>
                    </li>
                    <li>
                      <button id="Embed_btn" (click)="copyEmbed(clipboardInput)">Copy Embed</button>
                    </li>
                  </ul>
                </div>
              </em>
              <em [ngClass]="(item.imageAmpValidated)  ? 'ValidatedAmpImage' : 'NotValidatedAmpImage icon-image'"></em>
              <em *ngIf="item?.metadata?.ampStatus=='PASS' && enableAMPValidation" class="ValidatedAmpScore icon-breaking green">
                <div class="arrow_box single">Valid AMP</div>
              </em>
              <em *ngIf="item?.metadata?.ampStatus=='FAIL' && enableAMPValidation" class="ValidatedAmpScore icon-breaking red">
                <div class="arrow_box single">Invalid AMP</div>
              </em>
              <em
                [ngClass]="(item.metadata.markUnimportant)  ? 'notimportant icon-unimportant-active' : 'important icon-unimportant-inactive'"></em>
                <em (click)="getNotificationPopup(item)"
                [ngClass]="(item.metadata.notificationSent)  ? 'notimportant bellIcon' : ' '"></em>
                
                <!-- <em  class="redirectLink" *ngIf="item.metadata.status === 'PUBLISHED'" (click)="navigateToFrontendUrl(item)">
                  <i class="pickLink icomoon icon-broken-link"></i><div class="arrow_box single">View story</div>
                </em> -->
            </div>


            <ul (click)="onClickStory(item,'click')"[class.active]="!item.lockedByUserId" class="listingul" #listData2>
              <div #listEl  (ctrl-click)="onClickStory(item, 'ctrl-click')">

                <li class="headline spImg" [title]="item?.title">
                  <div class="relhidden">
                    <div class="listCell" [title]="item?.title" [innerHTML]="item?.title"></div>
                  </div>
                </li>

                <li class="format" [title]="item?.type">
                  <em class="breakingnews icon-breaking" *ngIf='(item?.metadata.breakingNews)'></em>
                  <em class="sponsored icon-Combined-Shape" *ngIf='(item?.metadata.sponsored)'></em>
                  <div class="relhidden">
                    <div class="listCell" [title]="item?.type">{{item?.type | titlecase}}</div>
                  </div>
                </li>

                <li *ngIf="!item.metadata.killed" class="status" >
                  <span [class]="item.metadata?.status?.toLowerCase()" (click)="$event.stopPropagation();navigateToFrontendUrl(item)">
                    {{item.metadata.status}} 
                    <ng-container *ngIf="enablePlagiarism && item.metadata.plagiarismChecked">
                      <img class="plag_icon" [title]="plagStatus(item)" [src]="plagIconCheck(item)" alt="">
                    </ng-container>  
                    <em  class="redirectLink" *ngIf="item.metadata.status === 'PUBLISHED'" >
                      <i class="related_icon spImg_story">
                        <img  alt="View Story" src="assets/images/link-out.png" width="12px" height="12px">
                      </i><div class="arrow_box single">View story</div>
                      
                    </em> 
                  </span>
                </li>
                <li *ngIf="item.metadata.killed" class="status">
                  <span class="killed">
                    KILLED
                  </span>
                </li>

                <li class="format" [title]="item.metadata?.section">
                  <div class="relhidden">
                    <div class="listCell" [title]="item.metadata?.section">{{item.metadata?.section | titlecase}}</div>
                  </div>
                </li>


                <ng-container *ngIf="isAuthorIdEnabled; then authorMap else authorArray"></ng-container>
                <ng-template #authorMap>
                  <ng-container
                    *ngIf="(item.metadata && item.metadata.authorsList && item.metadata.authorsList[0]);then authorm else blank">
                  </ng-container>
                </ng-template>
                <ng-template #authorArray>
                  <ng-container
                    *ngIf="(item.metadata && item.metadata.authors && item.metadata.authors[0]);then author else blank">
                  </ng-container>
                </ng-template>

                <ng-template #author>
                  <li class="author" [title]="item.metadata?.authors[0]">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.metadata?.authors[0]">
                        {{item.metadata?.authors[0] | titlecase}}</div>
                    </div>
                  </li>
                </ng-template>

                <ng-template #authorm>
                  <li class="author" [title]="item.metadata?.authorsList[0].name">
                    <div class="relhidden">
                      <div class="listCell" [title]="item.metadata?.authorsList[0].name">
                        {{item.metadata?.authorsList[0].name| titlecase}}</div>
                    </div>
                  </li>
                </ng-template>

                <ng-template #blank>
                  <li class="author">
                    <div class="relhidden">
                      <div class="listCell">-</div>
                    </div>
                  </li>
                </ng-template>


                <li class="lastupdae">{{getNewTypeDate(item.lastModifiedDate)}}</li>

                <li class="format" [title]="item.lastModifiedByUserName">
                  <div class="relhidden">
                    <div class="listCell" [title]="item.lastModifiedByUserName">
                      {{item.lastModifiedByUserName | titlecase}}</div>
                  </div>
                </li>
              </div>
            </ul>
          </div>

        </ng-container>
      </ng-container>
    </ng-template>
  </div>
</div>

  <!--  -->
  <div class="footerPagination">
    <div class="pagination" *ngIf="totalRecords > 50">Page
      <ul>
        <ng-container *ngIf="7 > pages">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            <!-- </ng-container> -->
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pages > 6">
          <ng-container *ngFor="let j of arrayOne(pages); let i = index">
            <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
              <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
            </ng-container>
          </ng-container>
          <li>..</li>
          <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
        </ng-container>
      </ul>
    </div>

    <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
    <ng-template #showPaging>
      <div id="singleRecordConformation" class="recordList">Showing
        <select id="dropDownRecordListInPagination" name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
          (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </div>
    </ng-template>
    <ng-template #displayPaging>
      <div id="singleRecordConformation" class="recordList borderNone">
        Showing {{totalRecords}} results</div>
    </ng-template>
  </div>
</div>


<div class="lightBox readstory block" *ngIf="unlockPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Unlock Story</h3>
      <p>{{lockedUser}} will be able to view this story in read mode now.</p>
    </div>
    <div id="scrollToDivForCropping" class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" (click)="cancelUnlock()" class="cancel gray mtb15 ml10">Cancel</button>
      <button type="button" name="unlock" (click)="unlockStory()" class="add blue mtb15 ml10 mr30">Unlock</button>
    </div>
  </div>
</div>

<div class="lightBox quickReads block" *ngIf="quickReadPopup">
  <div class="headerLight">
    <div class="close fl spImg" (click)="cancelQuickReads()"></div>
  </div>
  <div class="lightContent">
    <div class="summary_status">
      <div class="tabList">
        <h2 class="tablinks"  (click)="showQuickReads = true;showStoryParaView = false"
        [class]="showQuickReads ? 'active' : ' '" id="defaultOpen">Edit Quick Read</h2>
        <h2 class="tablinks"  (click)="showQuickReads = false;showStoryParaView = true;showMy = true; fetchParaContent();" [class]="showStoryParaView ? 'active' : ' '"  id="paraView" >Story Paragraph Content</h2>
      </div>
      <div>
      <label></label><span>{{storyData.quickReadStatus ? storyData.quickReadStatus : 'None'}}</span>
      </div>
    </div>
    <div id="showQuickReads" [style.display] = "showQuickReads ? 'block' : 'none'" style="display: block;">
    <div class="readView">
      <h3>Quick Read Summary</h3>
      <p>{{tempQuickRead}}</p>
    </div>
    <h3 class="changeTo">Edit Quick Read Summary <label>{{storyData.quickReadSummary ? htmlToPlaintext(storyData.quickReadSummary).split(' ').length : '0'}}/{{quickReadMax}}</label></h3>
    <!-- <label></label> -->
    <div class="editView">
      <textarea class="textAreaBox" placeholder="Enter the Quick Read summary here..." [(ngModel)]='storyData.quickReadSummary' rows="10" cols="">
      </textarea>
      <span id="quickSummaryError" *ngIf="storyData && storyData.quickReadSummary && storyData.quickReadSummary.split(' ').length>quickReadMax">
        must not exceed {{quickReadMax}} words.
     </span>
    </div>
    <div class="wid100 right borderTop">
      <button type="button" name="cancel" (click)="cancelQuickReads()" class="cancel gray ml10">Cancel</button>
      <button type="button" name="save" [disabled]="savingQuickReadInProgress" (click)="saveQuickReads()" class="add blue ml10 mr30">Save</button>
    </div>
  </div>
  <div class="pageContainer tabcontent" id="showStoryParaView" [style.display] = "showStoryParaView ? 'block' : 'none'"  *ngIf="showMy">
    <div class="storyParaView">
      <ng-container *ngFor="let item of viewParagraph;">
        <p [innerHtml]="item">  </p>
      </ng-container>
    </div>
    
  </div>

  </div>
</div>


<div class="lightBox quickReads block" *ngIf="openNotificationPopup">
  <div class="headerLight">
    <div class="close fl spImg" (click)="closesendNotifications()"></div>
  </div>
  <div class="lightContent">
    <ng-container *ngIf="notificationList && notificationList.length>0">
      <div class="notification_tab_status">
        <div class="tabList">
          <ng-container *ngFor="let item of notificationList; let i = index">
            <h2 class="tablinks" [ngClass]="{'active': i == tabIndexValue}" (click)="tabIndex(i)"> Tab {{i+1}} </h2>
            </ng-container>
        </div>
      </div>
      <div class="borderTop notificationPopupBody" *ngIf="notificationList[tabIndexValue]">
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
           Notification Type
          </div>
          <div class="col-8 notification-field">
            {{notificationList[tabIndexValue].notificationType ? notificationList[tabIndexValue].notificationType: '-'}}
          </div>
        </div>
        </div>
  
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
           Notification Title
          </div>
          <div class="col-8 notification-field">
            {{notificationList[tabIndexValue].title ? notificationList[tabIndexValue].title: '-'}}
          </div>
        </div>
        </div>
  
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
           Notification Description
          </div>
          <div class="col-8 notification-field">
            {{notificationList[tabIndexValue].description ? notificationList[tabIndexValue].description: '-'}}
          </div>
        </div>
        </div>
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
           URL
          </div>
          <div class="col-8 notification-field">
            <a [ngClass]="{'story-url': notificationList[tabIndexValue].storyUrl}" (click)="notificationList[tabIndexValue].storyUrl ? openStory(notificationList[tabIndexValue].storyUrl): null">{{notificationList[tabIndexValue].storyUrl ? notificationList[tabIndexValue].storyUrl: '-'}}</a>
          </div>
        </div>
        </div>
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
           Image URL
          </div>
          <div class="col-8 notification-field">
            <img *ngIf="notificationList[tabIndexValue].imageUrl" src="{{notificationList[tabIndexValue].imageUrl}}" width="100">
            <span *ngIf="!notificationList[tabIndexValue].imageUrl">-</span>
          </div>
        </div>
        </div>
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
           Notification Sent Date
          </div>
          <div class="col-8 notification-field">
            {{notificationList[tabIndexValue].createdDate?getNewTypeDate(notificationList[tabIndexValue].createdDate): '-'}}        
          </div>
        </div>
        </div>
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
            Target Applications        
          </div>
          <div class="col-8 notification-field">
            <ng-container  *ngIf="notificationList[tabIndexValue].appTypes && notificationList[tabIndexValue].appTypes.length>0">
              <span *ngFor="let data of notificationList[tabIndexValue].appTypes">{{data}},</span>
            </ng-container>
            <span *ngIf="!notificationList[tabIndexValue].appTypes">-</span>
          </div>
        </div>
        </div>
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
            Segment        
          </div>
          <div class="col-8 notification-field">
            <ng-container *ngIf="notificationList[tabIndexValue].segments && notificationList[tabIndexValue].segments.length>0">
              <span *ngFor="let data of notificationList[tabIndexValue].segments">{{data}},</span>
            </ng-container>
            <span *ngIf="!notificationList[tabIndexValue].segments">-</span>
          </div>
        </div>
        </div>
        <div class="container"> 
          <div class="row">
          <div class="col-4 notification-label">
            Moengage Segment        
          </div>
          <div class="col-8 notification-field">
            <ng-container *ngIf="notificationList[tabIndexValue].moSegments && notificationList[tabIndexValue].moSegments.length>0">
              <span *ngFor="let data of notificationList[tabIndexValue].moSegments">{{data}},</span>
            </ng-container>
            <span *ngIf="!notificationList[tabIndexValue].moSegments">-</span>
          </div>
        </div>
        </div>
      </div>
      <div id="showQuickReads" [style.display] = "showQuickReads ? 'block' : 'none'" style="display: block;">
      <div class="wid100 right borderTop notificationCancelBtn">
        <button type="button" name="cancel" (click)="closesendNotifications()" class="cancel gray">Cancel</button>
      </div>
    </div>
    </ng-container>
   <ng-container *ngIf="!notificationList || notificationList.length === 0">
      <p class="no-data-available">No Data Available</p>
   </ng-container>
  </div>
</div>
